import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-equipement',
  templateUrl: './manage-equipement.component.html',
  styleUrls: ['./manage-equipement.component.scss']
})
export class ManageEquipementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
